module.exports = __webpack_public_path__ + "img/locationpin.79bb8c58.png";